module.exports = __webpack_public_path__ + "static/media/GOOGLE_PAY.bbf30929.svg";